/* script */
//
//
//
//
//
//
//
//

// Utils
import { isString, isNumber } from 'lodash';

// Mixins
import cell from './cell';

const __vue_script__ = {
    name: 'SendNotificationCell',

    mixins: [cell],

    data() {
        return {
            formattedTime: undefined,
            sending: false,
        };
    },

    mounted() {
        this.formattedTime = this.formatSent(this.item.sent);
    },

    methods: {
        /** @param {string|number|undefined} sent */
        formatSent(sent) {
            // in older pkg-messages (v4.12.2 and below) "sent" is a formatted date
            // since then we use saveDocuments and "sent" is supposed to be a timestamp
            if (isString(sent)) {
                return sent;
            }
            if (isNumber(sent)) {
                return this.$utils.time.convertTimestampToHumanForm(
                    sent,
                    this.event.timezone,
                    // keeping the same format as in previous versions of pkg-messages
                    'YYYY/MM/DD HH:mm',
                );
            }
        },

        send() {
            const onConfirm = async () => {
                this.$modal.hide('dialog');
                this.sending = true;
                const response = await this.$services.appScripts.callAppScript(
                    this.event._id,
                    'messages/send-now',
                    { messageId: this.item._id },
                ).catch(err => {
                    console.error(`[SendNotificationCell] failed to send ${this.item._id}`, err);
                });

                if (response.sent) {
                    this.formattedTime = this.formatSent(response.sent);
                    this.$notify({
                        group: 'flashes',
                        text: this.$i18n.t('listings.messages.sent_notification').toString(),
                        type: 'success',
                        duration: 5000
                    });
                }

                this.sending = false;
            };
            this.$modal.show('dialog', {
                title: this.$t('listings.messages.send_notification'),
                text: this.$i18n.t(
                    'listings.messages.confirm_send_notification',
                    [(this.item?.targets || this.item?.exceptions) ? 'targeted' : 'all'],
                ).toString(),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        handler: () => { this.$modal.hide('dialog'); },
                        class: 'btn',
                    },
                    {
                        title: this.$t('listings.messages.send_now'),
                        handler: onConfirm,
                        class: 'btn btn-primary',
                    },
                ],
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-notification-cell"},[(_vm.formattedTime)?_c('span',[_vm._v(_vm._s(_vm.formattedTime))]):_vm._e(),(!_vm.sending && !_vm.formattedTime)?_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.send.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('listings.messages.send_now')))]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SendNotificationCell.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__